import { EvtHeader } from "components/header";
import { JOB_CONFIG } from "@/modules/work/jobs/constants";
import JobForm from "@/modules/work/jobs/form";
import Loader from "@/components/loader";
import { useParams } from "react-router-dom";
import { useProject } from "@/modules/work/projects/context";

const CreateJob = () => {
  const { data, isLoading } = useProject();

  const { type } = useParams();

  if (!JOB_CONFIG[type]) {
    const error = "Yeahhhh, fans gaya";
    throw error;
  }

  if (isLoading) return <Loader />;

  return (
    <div className="flex-1">
      <EvtHeader title={JOB_CONFIG[type].title} />
      <div className="p-6 max-w-md">
        <JobForm defaultProjectId={data.id} type={type} />
      </div>
    </div>
  );
};

export default CreateJob;
